export const scrollbarWidth = () => {
  document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.offsetWidth) + 'px');
}

export default scrollbarWidth;
